export const LOGO_URL =
  "https://nimbus-public.s3.amazonaws.com/WebResources/logos/wsp_logo_transparent_bg.png";
